/**
 * プレーンオブジェクトかどうか判定する。
 * @param obj
 * @returns {boolean}
 */
export function isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
